import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/notification_subscriptions',
  component: Management,
  redirect: '/notification_subscriptions/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/notification_subscriptions/List'),
      redirect: 'list/all',
      meta: {
        auth: Auth.listNotificationSubscriptions
      },
      children: [
        {
          path: 'all',
          component: () => import('@/views/notification_subscriptions/ListTable'),
          meta: {
            auth: Auth.listNotificationSubscriptions,
            tabName: 'all'
          }
        },
        // 订阅事项
        {
          path: 'alarm',
          component: () => import('@/views/notification_subscriptions/ListTable'),
          meta: {
            auth: Auth.listNotificationSubscriptions,
            tabName: 'alarm'
          }
        },
        {
          path: 'work_order',
          component: () => import('@/views/notification_subscriptions/ListTable'),
          meta: {
            auth: Auth.listNotificationSubscriptions,
            tabName: 'work_order'
          }
        },
        {
          path: 'product',
          component: () => import('@/views/notification_subscriptions/ListTable'),
          meta: {
            auth: Auth.listNotificationSubscriptions,
            tabName: 'product'
          }
        }
      ]
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/notification_subscriptions/New'),
      meta: {
        auth: Auth.createNotificationSubscription
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/notification_subscriptions/Edit'),
      meta: {
        auth: Auth.updateNotificationSubscription
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/notification_subscriptions/DetailLayout'),
      meta: {
        auth: Auth.showNotificationSubscription
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/notification_subscriptions/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showNotificationSubscription
          }
        },
        {
          path: 'subscription_trigger_records',
          component: () => import('@/views/notification_subscriptions/details/SubscriptionTriggerRecords'),
          meta: {
            tabName: 'subscription_trigger_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listSubscriptionTriggerRecords
          }
        },
        {
          path: 'notification_records',
          component: () => import('@/views/notification_subscriptions/details/NotificationRecords'),
          meta: {
            tabName: 'notification_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listNotificationRecords
          }
        }
      ]
    }
  ]
}
